/**
 * Filter State Helpers for Rate Review Module
 * @module RateReviewFilterStateHelpers
 */

/**
 * Initial filter state
 * @returns {Object} Initial filter state object
 */
export const getInitialFilterState = () => ({
  searchValue: "",
  phone: "",
  gatewayId: "",
  dateSubmitted: { start: null, end: null, preset: null, label: null },
  status: [],
});

/**
 * Initial filter loading states
 * @returns {Object} Initial filter loading states object
 */
export const getInitialFilterLoadingStates = () => ({
  searchValue: false,
  phone: false,
  gatewayId: false,
  dateSubmitted: false,
  status: false,
});

/**
 * Clears a specific filter
 * @param {string} filterName - Name of the filter to clear
 * @param {Object} currentFilters - Current filter state
 * @returns {Object} Updated filter state
 */
export const clearFilter = (filterName, currentFilters) => {
  if (filterName === 'dateSubmitted') {
    return {
      ...currentFilters,
      [filterName]: { start: null, end: null, preset: null, label: null },
    };
  }
  
  if (filterName === 'status') {
    return {
      ...currentFilters,
      [filterName]: [],
    };
  }
  
  return {
    ...currentFilters,
    [filterName]: "",
  };
};

